import * as Sentry from '@sentry/react';

export const setSentryUser = (id, email) => {
    try {
        Sentry.setUser({ id, email });
    } catch (e) {
        console.warn('[Observability] Failed to set Sentry user:', e);
    }
};

export const resetSentryContext = () => {
    try {
        Sentry.setUser(null);
    } catch (e) {
        console.warn('[Observability] Failed to reset Sentry context:', e);
    }
};

export const captureFrontendMessage = (message, level = 'info', context = {}) => {
    Sentry.captureMessage(message, { level, extra: context });
};

export const captureFrontendError = (error, context = {}) => {
    Sentry.captureException(error, { extra: context });
};
